import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['accessSettings/managersEmployers'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accessSettings/managersEmployers'],
        config: {
            headerName: getLocalizedString("email"),
            field: "Mail",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accessSettings/managersEmployers'],
        config: {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accessSettings/managersEmployers'],
        config: {
            headerName: getLocalizedString("functionaryTypePlant"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accessSettings/managersEmployers'],
        config: {
            headerName: getLocalizedString("group"),
            field: "Grupo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("namesAndLastnamesManagerEmployer"),
            field: "Apellidos y nombres (Managers/Empleadores)",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("email"),
            field: "Email",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("status"),
            field: "Status",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("documentRole"),
            field: "Rol",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("groupsWithAccess"),
            field: "Grupos con acceso",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("icariusAdministrator"),
            field: "Administrador de Icarius",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accessSettings],
        config: {
            headerName: getLocalizedString("canReceiveRequests"),
            field: "Puede recibir solicitudes",
            filter: "agSetColumnFilter",
        }
    },
]